<mat-list *ngIf="type == 'report' && files.report.length > 0">
  <mat-list-item *ngFor="let folder of files.report" class="cursor-pinter">
    <div
      mat-list-icon
      class="relative w-10 h-10 rounded-md overflow-hidden bg-accent-800"
      *ngIf="
        folder.extension.toLowerCase() === 'jpg' ||
        folder.extension.toLowerCase() === 'png' ||
        folder.extension.toLowerCase() === 'jpeg'
      "
    >
      <img
        class="object-cover w-full h-full rounded-md"
        [src]="folder.path"
        [alt]="folder.file_name"
      />
      <mat-icon
        class="absolute bottom-1 right-1 text-accent-500 opacity-80"
        svgIcon="image"
      ></mat-icon>
    </div>

    <mat-icon
      mat-list-icon
      *ngIf="folder.extension.toLowerCase() === 'pdf'"
      svgIcon="description"
    ></mat-icon>
    <mat-icon
      mat-list-icon
      *ngIf="folder.extension.toLowerCase() === 'mp4'"
      svgIcon="description"
    ></mat-icon>
    <div mat-line>{{ folder.file_name }}</div>
    <div mat-line class="text-secondary">{{ folder.created_at }}</div>
    <div mat-line class="text-secondary">{{ folder.created_by }}</div>
    <button mat-button (click)="downloadFile(folder.path, folder.file_name)">
      <mat-icon mat-list-icon svgIcon="download"></mat-icon>
    </button>
    <button mat-button (click)="moveToCategory(folder.file_id)">
      <mat-icon mat-list-icon svgIcon="drive_file_move"></mat-icon>
    </button>
  </mat-list-item>
</mat-list>

<mat-list *ngIf="type == 'project' && files.project.length > 0">
  <mat-list-item *ngFor="let folder of files.project" class="cursor-pinter">
    <div
      mat-list-icon
      class="relative w-10 h-10 rounded-md overflow-hidden bg-accent-800"
      *ngIf="
        folder.extension.toLowerCase() === 'jpg' ||
        folder.extension.toLowerCase() === 'png' ||
        folder.extension.toLowerCase() === 'jpeg'
      "
    >
      <img
        class="object-cover w-full h-full rounded-md"
        [src]="folder.path"
        [alt]="folder.file_name"
      />
      <mat-icon
        class="absolute bottom-1 right-1 text-accent-500 opacity-80"
        svgIcon="image"
      ></mat-icon>
    </div>

    <mat-icon
      mat-list-icon
      *ngIf="folder.extension.toLowerCase() === 'pdf'"
      svgIcon="description"
    ></mat-icon>
    <mat-icon
      mat-list-icon
      *ngIf="folder.extension.toLowerCase() === 'mp4'"
      svgIcon="description"
    ></mat-icon>
    <div mat-line>{{ folder.file_name }}</div>
    <div mat-line class="text-secondary">{{ folder.created_at }}</div>
    <div mat-line class="text-secondary">{{ folder.created_by }}</div>
    <button mat-button (click)="downloadFile(folder.path, folder.file_name)">
      <mat-icon mat-list-icon svgIcon="download"></mat-icon>
    </button>
    <button mat-button (click)="moveToCategory(folder.file_id)">
      <mat-icon mat-list-icon svgIcon="drive_file_move"></mat-icon>
    </button>
  </mat-list-item>
</mat-list>

<mat-list *ngIf="type == 'category'">
  <mat-list-item *ngFor="let folder of files.category" class="cursor-pinter">
    <div
      mat-list-icon
      class="relative w-10 h-10 rounded-md overflow-hidden bg-accent-800"
      *ngIf="
        folder.extension.toLowerCase() === 'jpg' ||
        folder.extension.toLowerCase() === 'png' ||
        folder.extension.toLowerCase() === 'jpeg'
      "
    >
      <img
        class="object-cover w-full h-full rounded-md"
        [src]="folder.path"
        [alt]="folder.file_name"
      />
      <mat-icon
        class="absolute bottom-1 right-1 text-accent-500 opacity-80"
        svgIcon="image"
      ></mat-icon>
    </div>

    <mat-icon
      mat-list-icon
      *ngIf="folder.extension.toLowerCase() === 'pdf'"
      svgIcon="description"
    ></mat-icon>
    <mat-icon
      mat-list-icon
      *ngIf="folder.extension.toLowerCase() === 'mp4'"
      svgIcon="description"
    ></mat-icon>
    <div mat-line>{{ folder.file_name }}</div>
    <div mat-line class="text-secondary">{{ folder.created_at }}</div>
    <div mat-line class="text-secondary">{{ folder.created_by }}</div>
    <button mat-button (click)="downloadFile(folder.path, folder.file_name)">
      <mat-icon mat-list-icon svgIcon="download"></mat-icon>
    </button>
    <button mat-button (click)="moveToCategory(folder.file_id)">
      <mat-icon mat-list-icon svgIcon="drive_file_move"></mat-icon>
    </button>
  </mat-list-item>
</mat-list>
